import React, { Suspense } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import "../css/media-query-custom.css";
import { DashboardPage } from "./pages/DashboardPage";
import { UserProfilePage } from "./pages/UserProfilePage";
import { AdminsPage } from "./application/Admin/pages/admins/AdminsPage";
import { AdminEdit } from "./application/Admin/pages/admins/admin-edit/AdminEdit";
import { CategoriesPage } from "./application/Admin/pages/categories/CategoriesPage";
import { CategoriesPageApproved } from "./application/Admin/pages/categories/CategoriesPageApproved";
import { CategoriesPageRejected } from "./application/Admin/pages/categories/CategoriesPageRejected";
import { CategoriesPagePending } from "./application/Admin/pages/categories/CategoriesPagePending";
import { CategoryEdit } from "./application/Admin/pages/categories/category-edit/CategoryEdit";
// Subcategory routes removed by user request
import { SubscriptionsPage } from "./application/Admin/pages/subscriptions/SubscriptionsPage";
import { SubscriptionsPageApproved } from "./application/Admin/pages/subscriptions/SubscriptionsPageApproved";
import { SubscriptionsPageUnapproved } from "./application/Admin/pages/subscriptions/SubscriptionsPageUnapproved";
import { BusinessesPage } from "./application/Admin/pages/businesses/BusinessesPage";
import { BusinessesPageApproved } from "./application/Admin/pages/businesses/BusinessesPageApproved";
import { BusinessesPageRejected } from "./application/Admin/pages/businesses/BusinessesPageRejected";
import { BusinessesPagePending } from "./application/Admin/pages/businesses/BusinessesPagePending";
import { BusinessesPageReported } from "./application/Admin/pages/businesses/BusinessesPageReported";
import { BusinessesPageDraft } from "./application/Admin/pages/businesses/BusinessesPageDraft";
import { BusinessEdit } from "./application/Admin/pages/businesses/business-edit/BusinessEdit";
import { UsersPage } from "./application/Admin/pages/users/UsersPage";
import { UserEdit } from "./application/Admin/pages/users/user-edit/UserEdit";
import { AdvertisementsPage } from "./application/Admin/pages/advertisements/AdvertisementsPage";
import { CountriesPage } from "./application/Admin/pages/countries/CountriesPage";
import { StatesPage } from "./application/Admin/pages/states/StatesPage";
import { CitiesPage } from "./application/Admin/pages/cities/CitiesPage";

import ErrorsPage from "./application/ErrorsExamples/ErrorsPage";
import { ErrorPage1 } from "./application/ErrorsExamples/ErrorPage1";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<ContentRoute component={DashboardPage} />} />
        <Route path="/user-profile" element={<ContentRoute component={UserProfilePage} />} />
        <Route path="/admin/new" element={<ContentRoute component={AdminEdit} />} />
        <Route path="/admin/:id/edit" element={<ContentRoute component={AdminEdit} />} />
        <Route path="/admin/*" element={<ContentRoute component={AdminsPage} />} />
        <Route path="/category/new" element={<ContentRoute component={CategoryEdit} />} />
        <Route path="/category/:id/edit" element={<ContentRoute component={CategoryEdit} />} />
        <Route path="/category/approved/*" element={<ContentRoute component={CategoriesPageApproved} />} />
        <Route path="/category/rejected" element={<ContentRoute component={CategoriesPageRejected} />} />
        <Route path="/category/pending/*" element={<ContentRoute component={CategoriesPagePending} />} />
        <Route path="/category/*" element={<ContentRoute component={CategoriesPage} />} />
        <Route path="/subscription/approved" element={<ContentRoute component={SubscriptionsPageApproved} />} />
        <Route path="/subscription/un-approved" element={<ContentRoute component={SubscriptionsPageUnapproved} />} />
        <Route path="/subscription/*" element={<ContentRoute component={SubscriptionsPage} />} />
        {/* Subcategory routes removed */}
        <Route path="/business/approved/*" element={<ContentRoute component={BusinessesPageApproved} />} />
        <Route path="/business/rejected/*" element={<ContentRoute component={BusinessesPageRejected} />} />
        <Route path="/business/pending/*" element={<ContentRoute component={BusinessesPagePending} />} />
        <Route path="/business/reported/*" element={<ContentRoute component={BusinessesPageReported} />} />
        <Route path="/business/draft/*" element={<ContentRoute component={BusinessesPageDraft} />} />
        <Route path="/business/new" element={<ContentRoute component={BusinessEdit} />} />
        <Route path="/business/:id/edit" element={<ContentRoute component={BusinessEdit} />} />
        <Route path="/business/*" element={<ContentRoute component={BusinessesPage} />} />
        <Route path="/user/new" element={<ContentRoute component={UserEdit} />} />
        <Route path="/user/:id/edit" element={<ContentRoute component={UserEdit} />} />
        <Route path="/user/*" element={<ContentRoute component={UsersPage} />} />
        <Route path="/advertisement/*" element={<ContentRoute component={AdvertisementsPage} />} />
        <Route path="/location/countries/*" element={<ContentRoute component={CountriesPage} />} />
        <Route path="/location/states/*" element={<ContentRoute component={StatesPage} />} />
        <Route path="/location/cities/*" element={<ContentRoute component={CitiesPage} />} />
        
        {/* Route Aliases */}
        <Route path="/country/*" element={<Navigate to="/location/countries" replace />} />
        <Route path="/state/*" element={<Navigate to="/location/states" replace />} />
        <Route path="/city/*" element={<Navigate to="/location/cities" replace />} />
        
        {/* Error Pages & 404 Fallback */}
        <Route path="/error/*" element={<ErrorsPage />} />
        <Route path="*" element={<ErrorPage1 />} />
      </Routes>
    </Suspense>
  );
}
